import getMagentoToken from '@tkww/reg-shared-util-get-magento-token';

const getAuthHeaders = async () => {
  const magentoCustomerToken = await getMagentoToken();

  const baseHeaders = {
    'tkww-application': 'fe-member-shopping',
  };

  if (!magentoCustomerToken) {
    return baseHeaders;
  }

  return {
    ...baseHeaders,
    Authorization: `Bearer ${magentoCustomerToken}`,
  };
};

export default getAuthHeaders;
